import PropTypes from "prop-types";
import Select from "react-select";
import React, { Fragment, useEffect, useState, useRef } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import {
  Button,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
  InputGroup
} from "reactstrap";
import AppConstant from "../../constants/app.constants";
import { DefaultColumnFilter } from "./filters";
import LeftArrow from "assets/images/page/left.png";
import NextArrow from "assets/images/page/next.png";
import PreviousArrow from "assets/images/page/previous.png";
import RightArrow from "assets/images/page/right.png";
import "./table-container.scss";
import { AiFillDelete } from 'react-icons/ai';
import { HiFunnel } from "react-icons/hi2";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { getAllEntity, getAllEntityAnchor, getEntityAnchorDeal } from "http/fundLync/entityAndAddress.helper";
import { callRMUsers, callReferredFinancier, callAcceptedFinancier, callRejectedFinancier, callGetCIUser, callStatusCount } from "http/fundLync/dealFinancier";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import {
  dealFilterList,
  entityFilterList,
  conditionOptions,
  dealStatusBucket,
  entityConstitution,
  meetingFilters,
} from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { formatDateString } from "pages/EntityDashboard/borrowingProfile";
import { format, parse } from "date-fns";
import { useLongPress } from 'use-long-press';

const GlobalFilter = ({
  totalRecords,
  setSearchFilter,
  handleClearSearch,
  handleTableFor,
  setCallFilter,
  activeTab,
}) => {
  const [hover, setHover] = useState(false);
  // Common
  const [value, setValue] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedFiltersView, setSelectedFiltersView] = useState([]);
  const [filterPopupVisible, setFilterPopupVisible] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [hoverTooltip, setHoverTooltip] = useState(false);

  // Company
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedCompanyList, setSelectedCompanyList] = useState([]);
  const [inputValueForCompany, setInputValueForCompany] = useState('');

  // Entity
  const [entityType, setEntityType] = useState([]);
  const [entityColumnList, setEntityColumnList] = useState(entityFilterList);
  const [selectedCompanyForEntity, setSelectedCompanyForEntity] = useState([]);
  const [selectedConstitution, setSelectedConstitution] = useState([]);
  const [selectedCompanyListForEntity, setSelectedCompanyListForEntity] = useState([])

  const [selectedAllEntityAnchor, setSelectedAllEntityAnchor] = useState([])
  const [selectedAnchor, setSelectedAnchor] = useState([]);
  const [inputValueForAnchor, setInputValueForAnchor] = useState('');

  const [selectedAllRM, setSelectedAllRM] = useState([])
  const [selectedRMEntity, setSelectedRMEntity] = useState([]);

  const [selectedAllRegion, setSelectedAllRegion] = useState([])
  const [selectedRegion, setSelectedRegion] = useState([]);

  const [selectedListForEntityAnchor, setSelectedListForEntityAnchor] = useState([])
  const [inputValueForEntityAnchor, setInputValueForEntityAnchor] = useState('');
  const [selectedEntityAnchor, setSelectedEntityAnchor] = useState([]);

  // Referred Financier
  const [referredFinanciersList, setReferredFinanciersList] = useState([])
  const [selectedReferredCompany, setSelectedReferredCompany] = useState([]);
  const [inputValueForReferredCompany, setInputValueForReferredCompany] = useState('');

  // Accepted Financier
  const [acceptedFinanciersList, setAcceptedFinanciersList] = useState([])
  const [selectedAcceptedCompany, setSelectedAcceptedCompany] = useState([]);
  const [inputValueForAcceptedCompany, setInputValueForAcceptedCompany] = useState('');

  // Rejected Financier
  const [rejectedFinanciersList, setRejectedFinanciersList] = useState([])
  const [selectedRejectedCompany, setSelectedRejectedCompany] = useState([]);
  const [inputValueForRejectedCompany, setInputValueForRejectedCompany] = useState('');

  // Deal
  const [selectedRM, setSelectedRM] = useState([]);
  const [selectedFIRM, setSelectedFIRM] = useState([]);
  const [selectedProgramManager, setSelectedProgramManager] = useState([]);

  const [dealColumnList, setDealColumnList] = useState(dealFilterList);
  const [productDropdownValues, setProductDropdownValues] = useState([]);
  const [subProductDropdownValues, setSubProductDropdownValues] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedFIRMUser, setSelectedFIRMUser] = useState([]);
  const [selectedPMUser, setSelectedPMUser] = useState([]);

  const [selectedProductType, setSelectedProductType] = useState([]);
  const [productTypeList, setProductTypeList] = useState([])
  const [selectedEntityType, setSelectedEntityType] = useState([])
  const [prosepectiveProductList, setProsepectiveProductList] = useState([]);
  const [ regionList, setRegionList ] = useState([])
  const [selectedProsepectiveProducts, setSelectedProsepectiveProducts] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [creditRatingList, setCreditRatingList] = useState([]);
  const [selectedCreditRatings, setSelectedCreditRatings] = useState([]);
  const [toastInfo, setToastInfo] = useState({
    message: "",
    showToast: false,
    role: "",
  });
  const [mandateOptions, setMandateOptions] = useState([]);
  const [selectedMandateOption, setSelectedMandateOption] = useState([]);
  const [dateFilters, setDateFilters] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);

  const flatpickrRef = useRef(null);
  const [mouOptions, setMouOptions] = useState([]);
  const [selectedMouOption, setSelectedMouOption] = useState([]);
  const [subProductTypeList, setSubProductTypeList] = useState([])
  const [showError, setShowError] = useState(false);
  const [selectedEntityStatus, setSelectedEntityStatus] = useState([])
  const [entityStatus, setEntityStatus] = useState([])

  // meeting
  const [meetingColumnList, setMeetingColumnList] = useState(meetingFilters);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState([]);
  const [dateFiltersMeeting, setDateFiltersMeeting] = useState({});
  const [selectedStatussMeeting, setSelectedStatussMeeting] = useState({});
  const [mediumMeeting, setSelectedMediumMeeting] = useState({});
  const [meetingStatus, setMeetingStatus] = useState([])
  const [allMedium, setAllMedium] = useState([])
  const [ selectedCompanyListForMeeting, setSelectedCompanyListForMeeting ] = useState([])
  const [selectedCompanyForMeeting, setSelectedCompanyForMeeting ] = useState([])
  const [inputValueForMeeting, setInputValueForMeeting] = useState('');

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLongPress = useLongPress(() => {
    if (isMobile) {
      setHoverTooltip(true);
      setFilterPopupVisible(false);
    }
  });

  const handleClick = () => {
    setFilterPopupVisible(!filterPopupVisible);
    setHoverTooltip(false);
    getDropDownForDeals()
  };
  const handleClickEntity = () => {
    setFilterPopupVisible(!filterPopupVisible);
    setHoverTooltip(false);
    getDropDownForEntity()
  };
  const handleClickMeeting = () => {
    setFilterPopupVisible(!filterPopupVisible);
    setHoverTooltip(false);
    getDropDownForMeetings()
  };

  const getDropDownForEntity = async () => {
    try {
      const entityResponseForEntity = await getAllEntity({ filter: "entity_filter", searchKey: "", nonFinancierType: "" });
      setSelectedCompanyListForEntity(entityResponseForEntity.data);
      
      const EntityAnchors = await getAllEntityAnchor({ filter: "entity_filter", searchKey: "", });
      setSelectedAllEntityAnchor(EntityAnchors.data);
      
      const ALlUSers = await callGetCIUser();
      setSelectedAllRM(ALlUSers.data.rows || []);
      
      const entityTypeResponse = await getDropDownList({ dropdownName: "Entity Type" });
      const entityTypeResponseValues = entityTypeResponse.data?.rows?.find(dv => dv.dropdownName === "Entity Type")?.dropdownValues || [];

      setEntityType(entityTypeResponseValues);

      const regionResponse = await getDropDownList({ dropdownName: "region" });
      const regionValues = regionResponse.data?.rows?.find(dv => dv.dropdownName === "region")?.dropdownValues || [];
      setSelectedAllRegion(regionValues);

      const entityStatusResponse = await getDropDownList({ dropdownName: "Entity Status Buckets" });
      const entityStatusResponseValues = entityStatusResponse.data?.rows?.find(dv => dv.dropdownName === "Entity Status Buckets")?.dropdownValues || [];

      setEntityStatus(entityStatusResponseValues);
    } catch (error) {
      console.error("Error fetching entity data:", error);
    }
  }

  const getDropDownForDeals = async () => {
    try {
      const entityResponseForEntityAnchor = await getEntityAnchorDeal();
      setSelectedListForEntityAnchor(entityResponseForEntityAnchor.data.rows || []);

      if (productTypeList.length == 0) {
        const productType = await getDropDownList({ dropdownName: "Product Type" });
        const productTypeValues = productType.data?.rows?.find(dv => dv.dropdownName === "Product type")?.dropdownValues || [];
        setProductTypeList(productTypeValues);
       
      } 

      if (productDropdownValues.length == 0) {

        const workingCapitalResponse = await getDropDownList({ dropdownName: "Working Capital" });
        const workingCapitalValues = workingCapitalResponse.data?.rows?.find(dv => dv.dropdownName === "Working Capital")?.dropdownValues || [];

        const termLoanResponse = await getDropDownList({ dropdownName: "Term Loan" });
        const termLoanValues = termLoanResponse.data?.rows?.find(dv => dv.dropdownName === 'Term loan')?.dropdownValues || [];

        const othersLeaseResponse = await getDropDownList({ dropdownName: "Others(Lease)" });
        const othersLeaseValues = othersLeaseResponse.data?.rows?.find(dv => dv.dropdownName === "Others(Lease)")?.dropdownValues || [];

        const struturedFinanceResponse = await getDropDownList({ dropdownName: "Structured Finance" });
        const struturedFinanceValues = struturedFinanceResponse.data?.rows?.find(dv => dv.dropdownName === "Structured Finance")?.dropdownValues || [];
        
        const allDropdownValues = [
          ...workingCapitalValues,
          ...termLoanValues,
          ...othersLeaseValues,
          ...struturedFinanceValues
        ];
        setProductDropdownValues(allDropdownValues);
        
      }

      if (subProductDropdownValues.length == 0) {
        const payableFinancingPayments = await getDropDownList({ dropdownName: "Payable Financing" });
        const payableFinancingPaymentsValues = payableFinancingPayments.data?.rows?.find(dv => dv.dropdownName === 'Payable Financing')?.dropdownValues || [];

        const receivableFinancingResponse = await getDropDownList({ dropdownName: "Receivable Financing" });
        const receivableFinancingResponseValues = receivableFinancingResponse.data?.rows?.find(dv => dv.dropdownName === "Receivable Financing")?.dropdownValues || [];

        const inventoryFundingResponse = await getDropDownList({ dropdownName: "Inventory funding" });
        const inventoryFundingResponseValues = inventoryFundingResponse.data?.rows?.find(dv => dv.dropdownName === "Inventory funding")?.dropdownValues || [];

        
        const debeturesResponse = await getDropDownList({ dropdownName: "Debetures" });
        const debeturesResponseValues = debeturesResponse.data?.rows?.find(dv => dv.dropdownName === "Debetures")?.dropdownValues || [];
        
        const cashCreditResponse = await getDropDownList({ dropdownName: "CC/OD" });
        const cashCreditResponseValues = cashCreditResponse.data?.rows?.find(dv => dv.dropdownName === "CC/OD")?.dropdownValues || [];

        // const overdraftResponse = await getDropDownList({ dropdownName: "CC/OD" });
        // const overdraftResponseValues = overdraftResponse.data?.rows?.find(dv => dv.dropdownName === "CC/OD")?.dropdownValues || [];
        
        const allDropDwonValuesForProductType = [
          ...payableFinancingPaymentsValues,
          ...receivableFinancingResponseValues,
          ...debeturesResponseValues,
          ...cashCreditResponseValues,
          ...inventoryFundingResponseValues,
          // ...overdraftResponseValues
        ]
        setSubProductDropdownValues(allDropDwonValuesForProductType);

      }

      if (entityType.length == 0) {
        const entityTypeResponse = await getDropDownList({ dropdownName: "Entity Type" });
        const entityTypeResponseValues = entityTypeResponse.data?.rows?.find(dv => dv.dropdownName === "Entity Type")?.dropdownValues || [];
        setEntityType(entityTypeResponseValues)
      }

      if (selectedCompanyList.length == 0) {
        const entityResponseForDeal = await getAllEntity({ filter: "deal_filter", searchKey: "", nonFinancierType: "" });
        setSelectedCompanyList(entityResponseForDeal?.data);
      }

      if (prosepectiveProductList.length == 0) {
        const prospectives = await getDropDownList({ dropdownName: "Prospective products" });
        const prospectiveValues = prospectives.data?.rows?.find(dv => dv.dropdownName === "Prospective products")?.dropdownValues || [];
        setProsepectiveProductList(prospectiveValues);
      } 
      if (regionList.length == 0) {
        const regions = await getDropDownList({ dropdownName: "region" });
        const regionsValues = regions.data?.rows?.find(dv => dv.dropdownName === "region")?.dropdownValues || [];
        setRegionList(regionsValues);
      } 
      if (creditRatingList.length == 0) {
        const creditRatings = await getDropDownList({ dropdownName: "Ratings" });
        const creditRatingsValues = creditRatings.data?.rows?.find(dv => dv.dropdownName === "Ratings")?.dropdownValues || [];
        setCreditRatingList(creditRatingsValues);
      } 

      setMandateOptions([
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' }
      ])

      setMouOptions([
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' }
      ])

      callReferredFinancier()
        .then(entityResponseForDeal => {
          setReferredFinanciersList(Array.isArray(entityResponseForDeal?.data) ? entityResponseForDeal.data : []);
        })
        .catch(error => {
          setReferredFinanciersList([]);
        });


      callAcceptedFinancier()
        .then(entityResponseForDeal => {
          setAcceptedFinanciersList(Array.isArray(entityResponseForDeal?.data?.rows) ? entityResponseForDeal?.data?.rows : []);
        })
        .catch(error => {
          setAcceptedFinanciersList([])
        });


      callRejectedFinancier()
        .then(entityResponseForDeal => {
          setRejectedFinanciersList(Array.isArray(entityResponseForDeal?.data?.rows) ? entityResponseForDeal?.data?.rows : []);
        })
        .catch(error => {
          setRejectedFinanciersList([]);
        });


      if (selectedRM.length == 0) {
        const rmUsersResponse = await callGetCIUser();
        setSelectedRM(rmUsersResponse?.data?.rows);
        setSelectedFIRM(rmUsersResponse?.data?.rows)
        setSelectedProgramManager(rmUsersResponse?.data?.rows)
      }

    } catch (error) {
      console.error(error);
    }
  }

  const getDropDownForMeetings = async () =>{
    const ALlUSers = await callGetCIUser();
      setSelectedAllRM(ALlUSers.data.rows || []);

      const meetingStatusResponse = await getDropDownList({ dropdownName: "Meeting_Status" });
      const meetingStatusResponseValues = meetingStatusResponse.data?.rows?.find(dv => dv.dropdownName === "Meeting_Status")?.dropdownValues || [];
      setMeetingStatus(meetingStatusResponseValues);

      const meetingResponse = await getDropDownList({ dropdownName: "Medium" });
      const meetingmediumResponseValues = meetingResponse.data?.rows?.find(dv => dv.dropdownName === "Medium")?.dropdownValues || [];
      const filteredDropdownValues = meetingmediumResponseValues.filter(
        (dv) => !["google meet", "offline"].includes(dv.displayName.toLowerCase())
      );
      setAllMedium(filteredDropdownValues);

      const entityResponseForEntity = await getAllEntity({ filter: "entity_filter", searchKey: "", nonFinancierType: "" });
      setSelectedCompanyListForMeeting(entityResponseForEntity.data);
    }
  const onChange = (value) => {
    setValue(value);
    setSearchFilter(value || undefined);
  };

  const toggleFilterPopup = () => {
    setFilterPopupVisible(!filterPopupVisible);
  };

  const handleSelectChange = (selectedOption) => {
    const newFilter = {
      label: selectedOption.label,
      value: selectedOption.value,
      condition: conditionOptions[0].value,
      filterValue: "",
    };
    setSelectedFilters([...selectedFilters, newFilter]);
    setDealColumnList(prevList =>
      prevList.filter(item => item.value !== selectedOption.value)
    );
  };
  const handleSelectChangeMeeting = (selectedOption) => {
    const newFilter = {
      label: selectedOption.label,
      value: selectedOption.value,
      condition: conditionOptions[0].value,
      filterValue: "",
    };
    setSelectedFilters([...selectedFilters, newFilter]);
    setMeetingColumnList(prevList =>
      prevList.filter(item => item.value !== selectedOption.value)
    );
  };

  const availableMeetingOptions = meetingColumnList.filter(option =>
    !selectedFilters.some(filter => filter.value === option.value)
  );
  const handleSelectChangeEntity = (selectedOption) => {
    const newFilter = {
      label: selectedOption.label,
      value: selectedOption.value,
      condition: conditionOptions[0].value,
      filterValue: "",
    };
    setSelectedFilters([...selectedFilters, newFilter]);

    setEntityColumnList(prevList =>
      prevList.filter(item => item.value !== selectedOption.value)
    );
  };

  const availableEntityOptions = entityColumnList.filter(option =>
    !selectedFilters.some(filter => filter.value === option.value)
  );

  const handleConditionChange = (index, condition) => {
    const newFilters = selectedFilters.map((filter, i) =>
      i === index ? { ...filter, condition: condition.value } : filter
    );
    setSelectedFilters(newFilters);
  };

  const saveFiltersToLocalStorage = (filters, tabIndex) => {
    let tableKey = '';

  if (handleTableFor === 'deal') {
    tableKey = `selectedFilters_deal_tab_${tabIndex}`;
  } else if (handleTableFor === 'entity') {
    tableKey = `selectedFilters_entity_tab_${tabIndex}`;
  } else if (handleTableFor === 'meeting') {
    tableKey = `selectedFilters_meetings_tab_${tabIndex}`;
  }
    localStorage.setItem(tableKey, JSON.stringify(filters));
  };
  
  const filterStateSetters = {
    "Deal Status": (filter) => setSelectedStatus(filter),
    "Company Name": (filter) => setSelectedCompany(filter),
    "Associated Anchors": (filter) => setSelectedEntityAnchor(filter),
    "RM": (filter) => setSelectedUser(filter),
    "FI RM": (filter) => setSelectedFIRMUser(filter),
    "Program Manager": (filter) => setSelectedPMUser(filter),
    "Prospective Product": (filter) => setSelectedProsepectiveProducts(filter),
    "Credit Ratings": (filter) => setSelectedCreditRatings(filter),
    "Mandate signed": (filter) => setSelectedMandateOption(filter),
    "MoU signed": (filter) => setSelectedMouOption(filter),
    "Product Type": (filter) => setSelectedProductType(filter),
    "Product": (filter) => setSelectedProducts(filter),
    "Sub Product": (filter) => setSubProductTypeList(filter),
    "Referred To Financiers": (filter) => setSelectedReferredCompany(filter),
    "Accepted By Financiers": (filter) => setSelectedAcceptedCompany(filter),
    "Rejected By Financiers": (filter) => setSelectedRejectedCompany(filter),
    "Entity Name": (filter) => setSelectedCompanyForEntity(filter),
    "Associated Anchors Entity": (filter) => setSelectedAnchor(filter),
    "Entity Type": (filter) => setSelectedEntityType(filter),
    "Constitution": (filter) => setSelectedConstitution(filter),
    "Constitution": (filter) => setSelectedConstitution(filter),
    "RM (Entity)" : (filter) => setSelectedRMEntity(filter),
    "Region" : (filter) => setSelectedRegion(filter),
    "Entity Region" : (filter) => setSelectedRegions(filter),
    "Filter By Entity": (filter) => setSelectedCompanyForMeeting(filter),
    "Created Date": (filter) => {
      setDateFilters({
        startDate: filter[0],
        endDate: filter[1],
      });
    },
    "Start Date": (filter) => {
      setDateFiltersMeeting({
        startDate: filter[0],
        endDate: filter[1],
      });
    },
    "Closure Date": (filter) => {
      setStartDate(filter.startDate);
      setEndDate(filter.endDate);
    },
    "Status" : (filter) => setSelectedEntityStatus(filter),
    "Meeting Status": (filter) => setSelectedStatussMeeting(filter),
    "Meeting Medium": (filter) => setSelectedMediumMeeting(filter),
    "Created By": (filter)=> setSelectedCreatedBy(filter)
  };

  const urlParams = new URLSearchParams(window.location.search);
  const dealsIds = urlParams.get("dealIDs");

  useEffect(() => {
    let tableKey = '';

  if (handleTableFor === 'deal') {
    tableKey = `selectedFilters_deal_tab_${activeTab}`;
  } else if (handleTableFor === 'entity') {
    tableKey = `selectedFilters_entity_tab_${activeTab}`;
  } else if (handleTableFor === 'meeting') {
    tableKey = `selectedFilters_meetings_tab_${activeTab}`;
  }
    
    const storedFilters = localStorage.getItem(tableKey);
    if (storedFilters  && !dealsIds) {
      try {
        const parsedFilters = JSON.parse(storedFilters);
        setSelectedFilters(parsedFilters);
        
        setSelectedFiltersView(parsedFilters);
        if (parsedFilters.length > 0) {
                setFilterApplied(true);
        parsedFilters.forEach((filter) => {
          setDealColumnList(prevList =>
            prevList.filter(item => item.value !== filter.value)
          );
          setMeetingColumnList(prevList =>
            prevList.filter(item => item.value !== filter.value)
          );
          setEntityColumnList(prevList =>
            prevList.filter(item => item.value !== filter.value)
          );
          
          const setFilterState = filterStateSetters[filter.label];
  
          if (setFilterState && filter.label !== "Closure Date" && filter.label !== "Created Date") {
            setFilterState({ label: filter.filterDisplay, value: filter.filterValue });
          }if (setFilterState && filter.label === "Closure Date" )  {
            setFilterState(filter.filterValue );
          }if (setFilterState &&  filter.label === "Created Date")  {
            setFilterState(filter.filterValue );
          }if (setFilterState &&  filter.label === "Start Date")  {
            setFilterState(filter.filterValue );
          }if (setFilterState && filter.label === "MoU signed" || filter.label === "Mandate signed")  {
            setFilterState({ label: filter.filterValue, value: filter.filterValue } );
          }
        });
      }
      } catch (error) {
        console.error('Error parsing filters from localStorage:', error);
      }
    }
 else {
      // Clear filters when switching tabs
      setSelectedFilters([]);
      setFilterApplied(false);
      handleClearFilters();
    }
  }, [activeTab, handleTableFor]);
  
  const handleFilterValueChange = (index, value, display,activeTab) => {
    const newFilters = selectedFilters.map((filter, i) =>
      i === index ? { ...filter, filterValue: value, filterDisplay:  display} : filter
    );
    setSelectedFilters(newFilters);
    // saveFiltersToLocalStorage(newFilters,activeTab);
  };

  useEffect(() => {
    if (currentIndex !== null) {
      handleDateChangeClosure(currentIndex);
    }
  }, [startDate, endDate, currentIndex]);
  const handleDateChangeClosure = (index) => {
    handleFilterValueChange(index, { startDate: startDate, endDate: endDate });
  } 

  const handleClearFilters = () => {
    setSelectedFilters([]);
    setDealColumnList(dealFilterList)
    setEntityColumnList(entityFilterList)
    setMeetingColumnList(meetingFilters)
    setSelectedProducts([]);
    setSelectedStatus([])
    setSelectedUser([])
    setSelectedRMEntity([])
    setSelectedRegion([])
    setSelectedCompany([])
    setSelectedCompanyForEntity([])
    setSelectedCompanyForMeeting([])
    setSelectedProductType([])
    setSubProductTypeList([])
    setSelectedEntityType([])
    setValue('')
    setSelectedConstitution([])
    setSelectedReferredCompany([])
    setSelectedAcceptedCompany([])
    setSelectedRejectedCompany([])
    setSelectedProsepectiveProducts([])
    setProsepectiveProductList([])
    setCreditRatingList([])
    setSelectedCreditRatings([])
    setSelectedMandateOption([])
    setSelectedMouOption([])
    setSelectedFIRMUser([])
    setSelectedPMUser([])
    setDateFilters({})
    
    flatpickrRef?.current?.flatpickr.clear();
    setEndDate('');
    setStartDate('')
    setFilterApplied(false)
    setSelectedEntityAnchor([])
    setSelectedAnchor([])
    // saveFiltersToLocalStorage([]); 
    setSelectedFiltersView([]);
    setSelectedRegions([])
    let tableKey = '';

    if (handleTableFor === 'deal') {
      tableKey = `selectedFilters_deal_tab_${activeTab}`;
    } else if (handleTableFor === 'entity') {
      tableKey = `selectedFilters_entity_tab_${activeTab}`;
    } else if (handleTableFor === 'meeting') {
      tableKey = `selectedFilters_meetings_tab_${activeTab}`;
    }
    localStorage.removeItem(tableKey);
    setSelectedEntityStatus([]);
    setSelectedCreatedBy([])
    setSelectedStatussMeeting([])
    setSelectedMediumMeeting([])
    setDateFiltersMeeting({})
  };

  const handleApplyFilters = () => {
    if (hasValidFilterValues(selectedFilters)) {
      setCallFilter(selectedFilters)
      setSelectedFiltersView(selectedFilters)
      setFilterPopupVisible(false)
      setFilterApplied(true)

      saveFiltersToLocalStorage(selectedFilters,activeTab);
    } else {
      setToastInfo({
        message: "Selected Field Empty in Filter",
        showToast: true,
        role: "error",
      });
    }
  };
  const getButtonColor = () => {
    if (filterPopupVisible) {
      return 'success'; // Color when popup is visible
    }
    if (filterApplied) {
      return '#007bac'; 
    }
    return 'light'; // Default color when no filters are applied and popup is not visible
  };

  const hasValidFilterValues = (filters) => {
    return filters.every(filter => {
      const value = filter.filterValue;
      if (filter.label === "Closure Date") {
        const { startDate, endDate } = filter.filterValue || {};
        // Check if both startDate and endDate are valid (not empty)
        return !(startDate === "" || endDate === "" || !startDate || !endDate);
      }
  
      // General check for other filters
      return !(value === "" || (Array.isArray(value) && value.length === 0));
    });
  };
  

  const handleClearFilter = (index) => {
    const removedFilter = selectedFilters[index];
    setSelectedFilters(prevFilters => prevFilters.filter((_, i) => i !== index));
    const insertIndex = dealFilterList.findIndex(item => item.value === removedFilter.value);
    handleDeleteFilter(removedFilter.label)
    setDealColumnList(prevList => [
      ...prevList.slice(0, insertIndex),
      { label: removedFilter.label, value: removedFilter.value },
      ...prevList.slice(insertIndex)
    ]);
  };

  const handleClearFilterForMeeting = (index) => {
    const removedFilter = selectedFilters[index];
    setSelectedFilters(prevFilters => prevFilters.filter((_, i) => i !== index));
    const insertIndex = meetingFilters.findIndex(item => item.value === removedFilter.value);
    handleDeleteFilter(removedFilter.label)
    setMeetingColumnList(prevList => [
      ...prevList.slice(0, insertIndex),
      { label: removedFilter.label, value: removedFilter.value },
      ...prevList.slice(insertIndex)
    ]);
  };

  const handleClearFilterForEntity = (index) => {
    const removedFilter = selectedFilters[index];
    setSelectedFilters(prevFilters => prevFilters.filter((_, i) => i !== index));
    const insertIndex = entityFilterList.findIndex(item => item.value === removedFilter.value);
    handleDeleteFilter(removedFilter.label)
    setEntityColumnList(prevList => {
      if (!prevList.some(item => item.value === removedFilter.value)) {
        return [
          ...prevList.slice(0, insertIndex),
          { label: removedFilter.label, value: removedFilter.value },
          ...prevList.slice(insertIndex)
        ];
      }
      return prevList;
    });
  
  };

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setDateFilters({
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }else{
      setDateFilters({
        startDate: selectedDates[0],
      })
    }
  };
  const handleDateChangeMeeting = (selectedDates) => {
    if (selectedDates.length === 2) {
      setDateFiltersMeeting({
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }else{
      setDateFiltersMeeting({
        startDate: selectedDates[0],
      })
    }
  };
  const handleDeleteFilter = (label) => {
    switch (label) {
      case 'Deal Status':
        setSelectedStatus([]);
        break;
      case 'Company Name':
        setSelectedCompany([]);
        setInputValueForCompany('');
        break;
      case 'Associated Anchors':
        setSelectedEntityAnchor([]);
        setInputValueForEntityAnchor('');
        break;
      case 'Associated Anchors Entity':
        setSelectedAnchor([]);
        setInputValueForAnchor("");
        break;
      case 'RM':
        setSelectedUser([]);
        break;
      case 'FI RM':
        setSelectedFIRMUser([]);
        break;
      case 'Program Manager':
        setSelectedPMUser([]);
        break;
      case 'Prospective Product':
        setSelectedProsepectiveProducts([]);
        break;
      case 'Credit Ratings':
        setSelectedCreditRatings([]);
        break;
      case 'Mandate signed':
        setSelectedMandateOption([]);
        break;
      case 'MoU signed':
        setSelectedMouOption([]);
        break;
      case 'Product Type':
        setSelectedProductType([]);
        break;
      case 'Product':
        setSelectedProducts([]);
        break;
      case 'Sub Product':
        setSubProductTypeList([]);
        break;
      case 'Referred To Financiers':
        setSelectedReferredCompany([]);
        setInputValueForReferredCompany('');
        break;
      case 'Accepted By Financiers':
        setSelectedAcceptedCompany([]);
        setInputValueForAcceptedCompany('');
        break;
      case 'Rejected By Financiers':
        setSelectedRejectedCompany([]);
        setInputValueForRejectedCompany('');
        break;
      case 'Created Date':
        setDateFilters({});
        break;
      case 'Entity Name':
        setInputValueForCompany('')
        setSelectedCompanyForEntity([])
        break;
      case 'Entity Type':
        setSelectedEntityType([]);
        break;
      case 'Constitution':
        setSelectedConstitution([]);
        break;
      case 'RM (Entity)':
        setSelectedRMEntity([]);
        break;
      case 'Region':
        setSelectedRegion([]);
        break;
      case 'Closure Date':
        setEndDate('');
        setStartDate('')
      case 'Status':
        setSelectedEntityStatus([])
        break;
      case 'Created By':
        setSelectedCreatedBy([])
        break;
      case "Start Date":
        setDateFiltersMeeting({})
        break;
      case 'Meeting Status':
        setSelectedStatussMeeting([])
        break;
      case "Entity Region":
        setSelectedRegions([])
        break;
      case "Filter By Entity":
        setSelectedCompanyForMeeting([])
        setInputValueForMeeting('')
        break;
      case 'Meeting Medium':
        setSelectedMediumMeeting([])
        break;
      default:
        break;
    }
  };
  const filteredConditionOptions = conditionOptions.filter(option => 
    option.value !== 'contains' && option.value !== 'not_contains'
  )
  const getAppliedFiltersTooltip = () => {
    if (!filterApplied || selectedFilters.length === 0) return null;
    return selectedFilters.map((filter, index) => (
      <div key={index}>
        {filter.label}: {Array.isArray(filter.filterValue) ? filter.filterValue.join(', ') : filter.filterValue}
      </div>
    ));
  };

  const formatExpectedClosureDate = (dateString) => {
    if (!dateString) return '';
    const date = parse(dateString, 'yyyy-MM', new Date());
    return format(date, 'MMMM, yyyy');
  };
  const formatCondition = (condition) => {
    return condition
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  return (
    <>
      <Col>
        <div className="search-box me-xxl-2 my-0 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={(e) => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`${totalRecords} records...`}
                value={value || ''}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {handleTableFor === 'deal' && (
        <>
          <div className="d-flex justify-content-start">
          <Button
            type="button"
            color={filterApplied ? undefined : getButtonColor()} 
            style={filterApplied ? { backgroundColor: getButtonColor(), borderColor: getButtonColor() } : {}} 
            className="mb-2 me-2"
            onClick={handleClick}
            onMouseEnter={() => !isMobile && setHover(true)}
            onMouseLeave={() => !isMobile && setHover(false)}
            {...handleLongPress()} 
          >
            <HiFunnel style={{ fontSize: '1rem' }} />
          </Button>
            <Button
              type="button"
              color="light"
              className="btn-rounded mb-2 me-2 ms-2 border-success"
              onClick={(e) => {
                handleClearSearch(e);
                handleClearFilters(e)
              }}
            >
              Clear
            </Button>
          </div>
          {(hover || hoverTooltip) && selectedFiltersView.length > 0 && (
            <div
              className="tooltip-content"
              style={{
                position: 'absolute',
                top: '38px',
                right: '0',
                background: '#dcdce4',
                zIndex: 1000,
                padding: '10px',
                borderRadius: '5px',
                maxWidth: '400px',
                width: '100%',
                textAlign: 'left',
                maxHeight: '200px',
                overflowY: 'auto',
                boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                scrollbarWidth: 'thin'
              }}
              onMouseEnter={() => setHoverTooltip(true)}
              onMouseLeave={() => setHoverTooltip(false)}
            >
              <h6>Applied Filters:</h6>
              <ul style={{ listStyleType: 'disc', padding: '10px' }}>
                {selectedFiltersView.map((filter, index) => (
                  <li key={index} style={{ marginBottom: '5px' }}>
                    <span style={{ color: '#22aa48' }}>{filter.label} -</span>{' '}
                    <span style={{ color: '#7e7c7d' }}>
                      {formatCondition(filter.condition)}:
                    </span>{' '}
                    <span style={{ color: '#2980b9' }}>
                      {filter.label === 'Deal Name' || filter.label === 'MoU signed' || filter.label === 'Mandate signed'
                        ? filter.filterValue
                        : filter.label === 'Created Date'
                          ? `${formatDateString(filter.filterValue[0]) || 'N/A'} to ${formatDateString(filter.filterValue[1]) || 'N/A'}`
                          : filter.label === 'Closure Date'
                            ? `${formatExpectedClosureDate(filter.filterValue.startDate) || 'N/A'} to ${formatExpectedClosureDate(filter.filterValue.endDate) || 'N/A'}`
                            : filter.filterDisplay?.join(', ') || 'N/A'}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <Col sm="1" className="ms-2 me-2">
            {filterPopupVisible && (
              <div
                className="filter-popup display-flex justify-content-end"
                style={{
                  position: 'absolute',
                  top: '2.4rem',
                  right: '0',
                  background: 'white',
                  boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  padding: '10px',
                  borderRadius: '5px',
                  minHeight: '350px',
                  maxHeight: '400px',
                  overflow: 'auto',
                  scrollbarWidth: 'thin',
                  maxWidth: '300px',
                  width: '100%',
                }}
              >
                <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                  <h5 style={{ margin: 0 }}>Filter Deals By</h5>
                  <button
                    type="button"
                    onClick={() => setFilterPopupVisible(false)}
                    style={{
                      border: 'none',
                      background: 'transparent',
                      fontSize: '1.2rem',
                      cursor: 'pointer',
                    }}
                  >
                    ×
                  </button>
                </div>

                <div
                  className="mb-3"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'rgba(0,0,0,0.1) rgba(0,0,0,0.05)',
                    padding: '0px 5px',
                  }}
                >
                  <Select
                    options={dealColumnList.map((option) => ({
                      label: option.label,
                      value: option.value,
                    }))}
                    placeholder="Enter Filter"
                    value={""}
                    onChange={handleSelectChange}
                  />
                </div>

                <div className="selected-filters" style={{ minHeight: '230px' }}>
                  {selectedFilters.map((filter, index) => (
                    <div
                      key={index}
                      className="selected-filter mb-3"
                      style={{
                        padding: '5px 0px',
                        backgroundColor: index % 2 === 0 ? 'rgb(244, 244, 244)' : 'white',
                      }}
                    >
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0rem 0.5rem',
                        }}
                      >
                        {filter.label}
                        <AiFillDelete
                          className="delete-icon"
                          onClick={() => {
                            if (handleTableFor == 'deal') {
                              handleClearFilter(index)
                            }else if (handleTableFor == 'meeting') {
                              handleClearFilterForMeeting(index)
                            }else {
                              handleClearFilterForEntity(index)
                            }
                          }}
                          style={{
                            cursor: 'pointer',
                            color: 'rgb(167, 167, 167)',
                          }}
                        />
                      </label>
                      <div style={{ padding: '0px 5px' }}>
                        {filter.label == "Deal Name" && (
                          <>
                            <Select
                              options={conditionOptions}
                              value={conditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />
                            <input
                              type="text"
                              className="form-control mt-2"
                              value={filter.filterValue}
                              onChange={(e) => handleFilterValueChange(index, e.target.value)}
                            />
                          </>
                        )}
                        {filter.label === "Deal Status" && (
                          <>
                            <Select
                              options={filteredConditionOptions}
                              value={filteredConditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />
                            <Select
                              className="mt-2"
                              isMulti
                              options={dealStatusBucket.map((option) => ({
                                label: option.displayName,
                                value: option.id,
                              }))}
                              value={selectedStatus}
                              onChange={(selectedOptions) => {
                                setSelectedStatus(selectedOptions);
                                handleFilterValueChange(
                                  index,
                                  selectedOptions.map((option) => option.value),
                                  selectedOptions.map((option) => option.label)
                                );
                              }}
                            />
                          </>
                        )}
                        {filter.label === "Company Name" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedCompanyList
                              .filter(option => option.entityName.toLowerCase().includes(inputValueForCompany.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              }))
                            }
                            placeholder="Type Company Name"
                            value={selectedCompany}
                            onInputChange={(value) => setInputValueForCompany(value)}
                            menuIsOpen={inputValueForCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedCompany(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Associated Anchors" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedListForEntityAnchor
                              .filter(option => option.entityName.toLowerCase().includes(inputValueForEntityAnchor.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              }))
                            }
                            placeholder="Type Entity Anchor Name"
                            value={selectedEntityAnchor}
                            onInputChange={(value) => setInputValueForEntityAnchor(value)}
                            // menuIsOpen={inputValueForEntityAnchor.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedEntityAnchor(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "RM" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedRM.map((option) => ({
                              label: `${option.firstName + " " + option.lastName}`,
                              value: option.id,
                            }))}
                            value={selectedUser}
                            onChange={(selectedOptions) => {
                              setSelectedUser(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Entity Region" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={regionList.map((option) => ({
                              label: `${option.displayName}`,
                              value: option.dropdownValue,
                            }))}
                            value={selectedRegions}
                            onChange={(selectedOptions) => {
                              setSelectedRegions(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "FI RM" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedFIRM.map((option) => ({
                              label: `${option.firstName + " " + option.lastName}`,
                              value: option.id,
                            }))}
                            value={selectedFIRMUser}
                            onChange={(selectedOptions) => {
                              setSelectedFIRMUser(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Program Manager" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedProgramManager.map((option) => ({
                              label: `${option.firstName + " " + option.lastName}`,
                              value: option.id,
                            }))}
                            value={selectedPMUser}
                            onChange={(selectedOptions) => {
                              setSelectedPMUser(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Prospective Product" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={prosepectiveProductList.map((option) => ({
                              label: `${option.displayName}`,
                              value: option.dropdownValue,
                            }))}
                            value={selectedProsepectiveProducts}
                            onChange={(selectedOptions) => {
                              setSelectedProsepectiveProducts(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Credit Ratings" && (
                          <>
                            <Select
                              options={conditionOptions}
                              value={conditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />

                            <Select
                              className="mt-2"
                              isMulti
                              options={creditRatingList.map((option) => ({
                                label: `${option.displayName}`,
                                value: option.dropdownValue,
                              }))}
                              value={selectedCreditRatings}
                              onChange={(selectedOptions) => {
                                setSelectedCreditRatings(selectedOptions);
                                handleFilterValueChange(
                                  index,
                                  selectedOptions.map((option) => option.value),
                                  selectedOptions.map((option) => option.label)
                                );
                              }}
                            />
                          </>
                        )}
                        {filter.label === "Mandate signed" && (
                          <Select
                            className="mt-2"
                            // isMulti
                            options={mandateOptions?.map((option) => ({
                              label: `${option.label}`,
                              value: option.value,
                            }))}
                            value={selectedMandateOption}
                            onChange={(selectedOptions) => {
                              setSelectedMandateOption(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.value,
                                selectedOptions.label
                              );
                            }}
                          />
                        )}
                        {filter.label === "MoU signed" && (
                          <Select
                            className="mt-2"
                            // isMulti
                            options={mouOptions?.map((option) => ({
                              label: `${option.label}`,
                              value: option.value,
                            }))}
                            value={selectedMouOption}
                            onChange={(selectedOptions) => {
                              setSelectedMouOption(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.value,
                                selectedOptions.label,
                              );
                            }}
                          />
                        )}
                        {filter.label === "Product Type" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={productTypeList.map((option) => ({
                              label: option.displayName,
                              value: option.displayName,
                            }))}
                            value={selectedProductType}
                            onChange={(selectedOptions) => {
                              setSelectedProductType(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Product" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={productDropdownValues.map((option) => ({
                              label: option.displayName,
                              value: option.displayName,
                            }))}
                            value={selectedProducts}
                            onChange={(selectedOptions) => {
                              setSelectedProducts(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Sub Product" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={subProductDropdownValues.map((option) => ({
                              label: option.displayName,
                              value: option.displayName,
                            }))}
                            value={subProductTypeList}
                            onChange={(selectedOptions) => {
                              setSubProductTypeList(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Referred To Financiers" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={Array.isArray(referredFinanciersList) && referredFinanciersList.length > 0 ? referredFinanciersList
                              // .filter(option => option.entityName.toLowerCase().includes(inputValueForReferredCompany.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              })) : []
                            }
                            placeholder="Type Entity Name"
                            value={selectedReferredCompany}
                            onInputChange={(value) => setInputValueForReferredCompany(value)}
                            // menuIsOpen={inputValueForReferredCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedReferredCompany(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Accepted By Financiers" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={Array.isArray(acceptedFinanciersList) && acceptedFinanciersList.length > 0 ? acceptedFinanciersList
                              // .filter(option => option.entityName.toLowerCase().includes(inputValueForAcceptedCompany.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              })) : []
                            }
                            placeholder="Type Entity Name"
                            value={selectedAcceptedCompany}
                            onInputChange={(value) => setInputValueForAcceptedCompany(value)}
                            // menuIsOpen={inputValueForAcceptedCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedAcceptedCompany(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Rejected By Financiers" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={Array.isArray(rejectedFinanciersList) && rejectedFinanciersList.length > 0 ? rejectedFinanciersList
                              // .filter(option => option.entityName.toLowerCase().includes(inputValueForRejectedCompany.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              })) : []
                            }
                            placeholder="Type Entity Name"
                            value={selectedRejectedCompany}
                            onInputChange={(value) => setInputValueForRejectedCompany(value)}
                            // menuIsOpen={inputValueForRejectedCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedRejectedCompany(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions?.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Created Date" && (
                          <Flatpickr
                            ref={flatpickrRef}
                            className="form-control"
                            placeholder="Start Date - End Date"
                            options={{
                              mode: 'range',
                              dateFormat: 'd-m-Y'
                            }}
                            value={dateFilters?.startDate && dateFilters?.endDate ? [dateFilters?.startDate, dateFilters?.endDate] : []}
                            onChange={(selectedOptions) => {
                              handleDateChange(selectedOptions)
                              handleFilterValueChange(
                                index,
                                selectedOptions?.map((option) => option)
                              );
                            }}
                          />
                        )}

                        {filter.label === "Closure Date" && (
                          <div className="d-flex flex-column gap-2">
                            <div className="d-flex flex-row align-items-center">
                              <label htmlFor="startDate" className="me-2">Start Date:</label>
                              <input
                                type="month"
                                value={startDate || ""}
                                onChange={(e) => {
                                  setStartDate(e.target.value);
                                  setCurrentIndex(index);
                                }}
                                className={`form-control ${!startDate && showError ? 'is-invalid' : ''}`}
                                id="startDate"
                                placeholder="MM/YYYY"
                              />
                            </div>
                            <div className="d-flex flex-row align-items-center">
                              <label htmlFor="endDate" className="me-2">End Date:</label>
                              <input
                                type="month"
                                value={endDate || ""}
                                onChange={(e) => {
                                  setEndDate(e.target.value)
                                  setCurrentIndex(index)
                                }}
                                className={`form-control`}
                                id="endDate"
                                placeholder="MM/YYYY"
                              />
                            </div>
                          </div>
                        )}

                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: 'end', marginTop: '10px' }}>
                  <Button
                    type="button"
                    color="light"
                    className="btn-rounded mb-2 me-2 border-success"
                    onClick={(e) => {
                      handleClearFilters(e),
                        handleClearSearch(e)
                    }}
                  >
                    Clear All
                  </Button>
                  <Button
                    type="button"
                    color="success"
                    className="btn-rounded mb-2"
                    onClick={handleApplyFilters}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            )}
          </Col>
        </>
      )}
      {handleTableFor === 'entity' && (
        <>
          <div className="d-flex justify-content-start">
            <Button
              type="button"
              color={filterApplied ? undefined : getButtonColor()}
              style={filterApplied ? { backgroundColor: getButtonColor(), borderColor: getButtonColor() } : {}}
              className="mb-2 me-2"
              onClick={handleClickEntity}
              onMouseEnter={() => !isMobile && setHover(true)}
              onMouseLeave={() => !isMobile && setHover(false)}
              {...handleLongPress()} 
            >
              <HiFunnel style={{ fontSize: '1rem' }} />
            </Button>

            <Button
              type="button"
              color="light"
              className="btn-rounded mb-2 me-2 ms-2 border-success"
              onClick={(e) => {
                handleClearSearch(e),
                  handleClearFilters(e)
              }}
            >
              Clear
            </Button>
          </div>
          {(hover || hoverTooltip) && selectedFiltersView.length > 0 &&  (
            <div
              className="tooltip-content"
              style={{
                position: 'absolute',
                top: '38px',
                right: '0',
                background: '#dcdce4',
                zIndex: 1000,
                padding: '10px',
                borderRadius: '5px',
                maxWidth: '400px',
                width: '100%',
                textAlign: 'left',
                maxHeight: '200px',
                overflowY: 'auto',
                boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                scrollbarWidth: 'thin'
              }}
              onMouseEnter={() => setHoverTooltip(true)} 
              onMouseLeave={() => setHoverTooltip(false)} 
              >
              <h6>Applied Filters:</h6>
              <ul style={{ listStyleType: 'disc', padding: '10px' }}>
              {selectedFiltersView.map((filter, index) => {
                return( 
                <li key={index} style={{ marginBottom: '5px' }}>
                  
                  <span style={{ color: '#22aa48' }}>
                    {filter.label} -
                  </span>{' '}
                  <span style={{ color: '#7e7c7d' }}>
                    {formatCondition(filter.condition)}:
                  </span>{' '}
                  <span style={{ color: '#2980b9' }}>
                    {filter.label === "PAN" || filter.label === "GSTN" || filter.label === "Mandate signed"
                      ? filter.filterValue 
                      : filter.filterDisplay?.join(', ') || 'N/A'}
                  </span>
                </li>)
              })}
              </ul>
            </div>
          )}
          <Col sm="1" className="ms-2 me-2">
            {filterPopupVisible && (
              <div
                className="filter-popup display-flex justify-content-end"
                style={{
                  position: 'absolute',
                  top: '2.4rem',
                  right: '0',
                  background: 'white',
                  boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  padding: '10px',
                  borderRadius: '5px',
                  minHeight: '350px',
                  maxHeight: '400px',
                  overflow: 'auto',
                  scrollbarWidth: 'thin',
                  maxWidth: '300px',
                  width: '100%',
                }}
              >
                <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                  <h5 style={{ margin: 0 }}>Filter Entities By</h5>
                  <button
                    type="button"
                    onClick={(e) => {
                      setFilterPopupVisible(false)
                      // handleClearFilters(e)
                      // handleClearSearch(e)
                    }}
                    style={{
                      border: 'none',
                      background: 'transparent',
                      fontSize: '1.2rem',
                      cursor: 'pointer',
                    }}
                  >
                    ×
                  </button>
                </div>

                <div
                  className="mb-3"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'rgba(0,0,0,0.1) rgba(0,0,0,0.05)',
                    padding: '0px 5px',
                  }}
                >
                  <Select
                    options={entityColumnList.map((option) => ({
                      label: option.label,
                      value: option.value,
                    }))}
                    placeholder="Enter Filter"
                    value={""}
                    onChange={handleSelectChangeEntity}
                  />
                </div>

                <div className="selected-filters" style={{ minHeight: '230px' }}>
                  {selectedFilters.map((filter, index) => (
                    <div
                      key={index}
                      className="selected-filter mb-3"
                      style={{
                        padding: '5px 0px',
                        backgroundColor: index % 2 === 0 ? 'rgb(244, 244, 244)' : 'white',
                      }}
                    >
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0rem 0.5rem',
                        }}
                      >
                        {filter.label}
                        <AiFillDelete
                          className="delete-icon"
                          onClick={() => {
                            if (handleTableFor == 'deal') {
                              handleClearFilter(index)
                            }else if (handleTableFor == 'meeting') {
                              handleClearFilterForMeeting(index)
                            }else {
                              handleClearFilterForEntity(index)
                            }
                          }}
                          style={{
                            cursor: 'pointer',
                            color: 'rgb(167, 167, 167)',
                          }}
                        />
                      </label>
                      <div style={{ padding: '0px 5px' }}>
                        {filter.label === "Entity Name" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedCompanyListForEntity
                              .filter(option => option.entityName.toLowerCase().includes(inputValueForCompany.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.entityName,
                              }))
                            }
                            placeholder="Type Company Name"
                            value={selectedCompanyForEntity}
                            onInputChange={(value) => setInputValueForCompany(value)}
                            menuIsOpen={inputValueForCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedCompanyForEntity(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}

                        {filter.label === "Associated Anchors Entity" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedAllEntityAnchor
                              .filter(option => option.entityName.toLowerCase().includes(inputValueForAnchor.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              }))
                            }
                            placeholder="Type Anchor Name"
                            value={selectedAnchor}
                            onInputChange={(value) => setInputValueForAnchor(value)}
                            // menuIsOpen={inputValueForCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedAnchor(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}

                        {filter.label === "RM (Entity)" && (
                          <Select
                          className="mt-2"
                          isMulti
                          options={selectedAllRM.map((option) => ({
                            label: `${option.firstName + " " + option.lastName}`,
                            value: option.id,
                          }))}
                          value={selectedRMEntity}
                          onChange={(selectedOptions) => {
                            setSelectedRMEntity(selectedOptions);
                            handleFilterValueChange(
                              index,
                              selectedOptions.map((option) => option.value),
                              selectedOptions.map((option) => option.label)
                            );
                          }}
                        />
                        )}

                        {filter.label === "Region" && (
                          <>
                            <Select
                              className="mt-2"
                              isMulti
                              options={selectedAllRegion.map((option) => ({
                                label: `${option.displayName}`,
                                value: option.dropdownValue,
                              }))}
                              value={selectedRegion}
                              onChange={(selectedOptions) => {
                                setSelectedRegion(selectedOptions);
                                handleFilterValueChange(
                                  index,
                                  selectedOptions.map((option) => option.value),
                                  selectedOptions.map((option) => option.label)
                                );
                              }}
                            />
                          </>
                        )}

                        {filter.label == "PAN" && (
                          <>
                            <Select
                              options={conditionOptions}
                              value={conditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />
                            <input
                              type="text"
                              className="form-control mt-2"
                              value={filter.filterValue}
                              onChange={(e) => handleFilterValueChange(index, e.target.value)}
                            />
                          </>
                        )}
                        {filter.label == "GSTN" && (
                          <>
                            <Select
                              options={conditionOptions}
                              value={conditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />
                            <input
                              type="text"
                              className="form-control mt-2"
                              value={filter.filterValue}
                              onChange={(e) => handleFilterValueChange(index, e.target.value)}
                            />
                          </>
                        )}
                        {filter.label === "Entity Type" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={entityType.map((option) => ({
                              label: option.displayName,
                              value: option.displayName,
                            }))}
                            value={selectedEntityType}
                            onChange={(selectedOptions) => {
                              setSelectedEntityType(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Constitution" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={entityConstitution.map((option) => ({
                              label: option.displayName,
                              value: option.displayName,
                            }))}
                            value={selectedConstitution}
                            onChange={(selectedOptions) => {
                              setSelectedConstitution(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Status" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={entityStatus?.map((option) => ({
                              label: `${option.dropdownValue}`,
                              value: option.dropdownValue,
                            }))}
                            value={selectedEntityStatus}
                            onChange={(selectedOptions) => {
                              setSelectedEntityStatus(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: 'end', marginTop: '10px' }}>
                  <Button
                    type="button"
                    color="light"
                    className="btn-rounded mb-2 me-2 border-1 border-success"
                    onClick={(e) => {
                      handleClearFilters(e),
                        handleClearSearch(e)
                    }}
                  >
                    Clear All
                  </Button>
                  <Button
                    type="button"
                    color="success"
                    className="btn-rounded mb-2"
                    onClick={handleApplyFilters}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            )}
          </Col>
        </>
      )}
      {handleTableFor === 'meeting' && (
        <>
          <div className="d-flex justify-content-start">
            <Button
              type="button"
              color={filterApplied ? undefined : getButtonColor()}
              style={filterApplied ? { backgroundColor: getButtonColor(), borderColor: getButtonColor() } : {}}
              className="mb-2 me-2"
              onClick={handleClickMeeting}
              onMouseEnter={() => !isMobile && setHover(true)}
              onMouseLeave={() => !isMobile && setHover(false)}
              {...handleLongPress()} 
            >
              <HiFunnel style={{ fontSize: '1rem' }} />
            </Button>

            <Button
              type="button"
              color="light"
              className="btn-rounded mb-2 me-2 ms-2 border-success"
              onClick={(e) => {
                handleClearSearch(e),
                  handleClearFilters(e)
              }}
            >
              Clear
            </Button>
          </div>
          {(hover || hoverTooltip) && selectedFiltersView.length > 0 &&  (
            <div
              className="tooltip-content"
              style={{
                position: 'absolute',
                top: '38px',
                right: '0',
                background: '#dcdce4',
                zIndex: 1000,
                padding: '10px',
                borderRadius: '5px',
                maxWidth: '400px',
                width: '100%',
                textAlign: 'left',
                maxHeight: '200px',
                overflowY: 'auto',
                boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                scrollbarWidth: 'thin'
              }}
              onMouseEnter={() => setHoverTooltip(true)} 
              onMouseLeave={() => setHoverTooltip(false)} 
              >
              <h6>Applied Filters:</h6>
              <ul style={{ listStyleType: 'disc', padding: '10px' }}>
                {selectedFiltersView?.map((filter, index) => {
                  return (<li key={index} style={{ marginBottom: '5px' }}>

                    <span style={{ color: '#22aa48' }}>
                      {filter.label} -
                    </span>{' '}
                    <span style={{ color: '#7e7c7d' }}>
                      {formatCondition(filter.condition)}:
                    </span>{' '}
                    <span style={{ color: '#2980b9' }}>
                      {filter.label === "Deal Name" || filter.label === "MoU signed" || filter.label === "Mandate signed"
                        ? filter.filterValue
                        : filter.label === "Start Date"
                          ? `${formatDateString(filter.filterValue[0]) || 'N/A'} to ${formatDateString(filter.filterValue[1]) || 'N/A'}`
                          : filter.label === "Closure Date"
                            ? `${formatExpectedClosureDate(filter.filterValue.startDate)|| 'N/A'} to ${formatExpectedClosureDate(filter.filterValue.endDate) || 'N/A'}`
                            : filter.filterDisplay?.join(', ') || 'N/A'}
                    </span>
                  </li>)
                })}
              </ul>
            </div>
          )}
          <Col sm="1" className="ms-2 me-2">
            {filterPopupVisible && (
              <div
                className="filter-popup display-flex justify-content-end"
                style={{
                  position: 'absolute',
                  top: '2.4rem',
                  right: '0',
                  background: 'white',
                  boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  padding: '10px',
                  borderRadius: '5px',
                  minHeight: '350px',
                  maxHeight: '400px',
                  overflow: 'auto',
                  scrollbarWidth: 'thin',
                  maxWidth: '300px',
                  width: '100%',
                }}
              >
                <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                  <h5 style={{ margin: 0 }}>Filter Entities By</h5>
                  <button
                    type="button"
                    onClick={(e) => {
                      setFilterPopupVisible(false)
                      // handleClearFilters(e)
                      // handleClearSearch(e)
                    }}
                    style={{
                      border: 'none',
                      background: 'transparent',
                      fontSize: '1.2rem',
                      cursor: 'pointer',
                    }}
                  >
                    ×
                  </button>
                </div>

                <div
                  className="mb-3"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'rgba(0,0,0,0.1) rgba(0,0,0,0.05)',
                    padding: '0px 5px',
                  }}
                >
                  <Select
                    options={meetingColumnList.map((option) => ({
                      label: option.label,
                      value: option.value,
                    }))}
                    placeholder="Enter Filter"
                    value={""}
                    onChange={handleSelectChangeMeeting}
                  />
                </div>

                <div className="selected-filters" style={{ minHeight: '230px' }}>
                  {selectedFilters.map((filter, index) => (
                    <div
                      key={index}
                      className="selected-filter mb-3"
                      style={{
                        padding: '5px 0px',
                        backgroundColor: index % 2 === 0 ? 'rgb(244, 244, 244)' : 'white',
                      }}
                    >
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0rem 0.5rem',
                        }}
                      >
                        {filter.label}
                        <AiFillDelete
                          className="delete-icon"
                          onClick={() => {
                            if (handleTableFor == 'deal') {
                              handleClearFilter(index)
                            } else if(handleTableFor == 'meeting'){
                              handleClearFilterForMeeting(index)
                            }else {
                              handleClearFilterForEntity(index)
                            }
                          }}
                          style={{
                            cursor: 'pointer',
                            color: 'rgb(167, 167, 167)',
                          }}
                        />
                      </label>
                      <div style={{ padding: '0px 5px' }}>

                        {filter.label === "Associated Anchors Entity" && (
                          <Select
                            className="mt-2"
                            isMulti
                            options={selectedAllEntityAnchor
                              .filter(option => option.entityName.toLowerCase().includes(inputValueForAnchor.toLowerCase()))
                              .map(option => ({
                                label: option.entityName,
                                value: option.id,
                              }))
                            }
                            placeholder="Type Anchor Name"
                            value={selectedAnchor}
                            onInputChange={(value) => setInputValueForAnchor(value)}
                            // menuIsOpen={inputValueForCompany.length >= 2}
                            onChange={(selectedOptions) => {
                              setSelectedAnchor(selectedOptions);
                              handleFilterValueChange(
                                index,
                                selectedOptions.map((option) => option.value),
                                selectedOptions.map((option) => option.label)
                              );
                            }}
                          />
                        )}
                        
                        {filter.label === "Start Date" && (
                          <Flatpickr
                            ref={flatpickrRef}
                            className="form-control"
                            placeholder="Start Date - End Date"
                            options={{
                              mode: 'range',
                              dateFormat: 'd-m-Y'
                            }}
                            value={dateFiltersMeeting?.startDate && dateFiltersMeeting?.endDate ? [dateFiltersMeeting?.startDate, dateFiltersMeeting?.endDate] : []}
                            onChange={(selectedOptions) => {
                              handleDateChangeMeeting(selectedOptions)
                              handleFilterValueChange(
                                index,
                                selectedOptions?.map((option) => option)
                              );
                            }}
                          />
                        )}
                        {filter.label === "Filter By Entity" && (
                          <Select
                          className="mt-2"
                          isMulti
                          options={selectedCompanyListForMeeting
                            .filter(option => option.entityName.toLowerCase().includes(inputValueForCompany.toLowerCase()))
                            .map(option => ({
                              label: option.entityName,
                              value: option.id,
                            }))
                          }
                          placeholder="Type Entity Name"
                          value={selectedCompanyForMeeting}
                          onInputChange={(value) => setInputValueForMeeting(value)}
                          menuIsOpen={inputValueForMeeting.length >= 2}
                          onChange={(selectedOptions) => {
                            setSelectedCompanyForMeeting(selectedOptions);
                            handleFilterValueChange(
                              index,
                              selectedOptions.map((option) => option.value),
                              selectedOptions.map((option) => option.label)
                            );
                          }}
                        />
                        )}
                        {filter.label === "Created By" && (
                          <Select
                          className="mt-2"
                          isMulti
                          options={selectedAllRM.map((option) => ({
                            label: `${option.firstName + " " + option.lastName}`,
                            value: option.id,
                          }))}
                          value={selectedCreatedBy}
                          onChange={(selectedOptions) => {
                            setSelectedCreatedBy(selectedOptions);
                            handleFilterValueChange(
                              index,
                              selectedOptions.map((option) => option.value),
                              selectedOptions.map((option) => option.label)
                            );
                          }}
                        />
                        )}
                        {filter.label === "Meeting Status" && (
                          <>
                            <Select
                              options={filteredConditionOptions}
                              value={filteredConditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />

                            <Select
                              className="mt-2"
                              isMulti
                              options={meetingStatus.map((option) => ({
                                label: `${option.displayName}`,
                                value: option.dropdownValue,
                              }))}
                              value={selectedStatussMeeting}
                              onChange={(selectedOptions) => {
                                setSelectedStatussMeeting(selectedOptions);
                                handleFilterValueChange(
                                  index,
                                  selectedOptions.map((option) => option.value),
                                  selectedOptions.map((option) => option.label)
                                );
                              }}
                            />
                          </>
                        )}
                        {filter.label === "Meeting Medium" && (
                          <>
                            <Select
                              options={filteredConditionOptions}
                              value={filteredConditionOptions.find(option => option.value === filter.condition)}
                              onChange={(selectedOption) => handleConditionChange(index, selectedOption)}
                            />

                            <Select
                              className="mt-2"
                              isMulti
                              options={allMedium.map((option) => ({
                                label: `${option.displayName}`,
                                value: option.dropdownValue,
                              }))}
                              value={mediumMeeting}
                              onChange={(selectedOptions) => {
                                setSelectedMediumMeeting(selectedOptions);
                                handleFilterValueChange(
                                  index,
                                  selectedOptions.map((option) => option.value),
                                  selectedOptions.map((option) => option.label)
                                );
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                  
                </div>
                <div style={{ textAlign: 'end', marginTop: '10px' }}>
                  <Button
                    type="button"
                    color="light"
                    className="btn-rounded mb-2 me-2 border-1 border-success"
                    onClick={(e) => {
                      handleClearFilters(e),
                        handleClearSearch(e)
                    }}
                  >
                    Clear All
                  </Button>
                  <Button
                    type="button"
                    color="success"
                    className="btn-rounded mb-2"
                    onClick={handleApplyFilters}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            )}
          </Col>
        </>
      )}
      {(handleTableFor !== 'deal' && handleTableFor !== 'entity'  && handleTableFor !== 'meeting') && (<Col>
        <Button
          type="button"
          color="light"
          className="btn-rounded mb-2 me-2 ms-2 border-success"
          onClick={(e) => {
            handleClearSearch(e),
              handleClearFilters(e)
          }}
        >
          Clear
        </Button>
      </Col>)}
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </>
  );
};

const TableContainerV1 = ({
  columns,
  data,
  pagination,
  handlePageChange,
  handleSearchFilter,
  handleSortColumn,
  customSection,
  handleClearSearch,
  sortOptions,
  customPageSize = AppConstant.TABLE_RECORD_SIZE,
  className,
  customPageSizeOptions = AppConstant.TABLE_RECORD_OPTIONS,
  hideSearchView = false,
  hidePageSize = false,
  tableFor,
  handleFilter,
  tabIndex,
  activeTab,
  tableWidth
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: customPageSize || AppConstant.TABLE_RECORD_SIZE,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const { pageIndex = 0, pageCount = 0, totalRecords = 0 } = pagination || {}
  const [pageNumberArray, setPageNumberArray] = useState([])
  const [isScrollable, setIsScrollable] = useState(false);
  const tableContainerRef = useRef(null);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  if (!tableWidth) {
    tableWidth = "100%";
  }
  const scrollable = true; 

  useEffect(() => {
    if (tableFor == "entity") {
      const checkScrollable = () => {
        if (tableContainerRef.current) {
          setIsScrollable(tableContainerRef.current.scrollWidth > tableContainerRef.current.clientWidth);
          getVisibleColumns(headerGroups[0].headers, tableContainerRef.current.clientWidth, tableContainerRef.current.scrollWidth > tableContainerRef.current.clientWidth)
        }
      };
      const debouncedCheckScrollable = debounce(checkScrollable, 100);
      checkScrollable();
      window.addEventListener('resize', debouncedCheckScrollable);
      return () => window.removeEventListener('resize', debouncedCheckScrollable);
    }
    if (activeTab == tabIndex) {
      const checkScrollable = () => {
        if (tableContainerRef.current) {
          setIsScrollable(tableContainerRef.current.scrollWidth > tableContainerRef.current.clientWidth);
          getVisibleColumns(headerGroups[0].headers, tableContainerRef.current.clientWidth, tableContainerRef.current.scrollWidth > tableContainerRef.current.clientWidth)
        }
      };
      const debouncedCheckScrollable = debounce(checkScrollable, 100);
      checkScrollable();
      window.addEventListener('resize', debouncedCheckScrollable);
      return () => window.removeEventListener('resize', debouncedCheckScrollable);
    }
  }, [activeTab, tableContainerRef, tabIndex, pageIndex, pageCount]);

  useEffect(() => {
    setPageNumberArray([]);
    const minPage = Math.min(7, pageCount);
    const currentPage = pageIndex + 1;

    if (pageCount <= 7) {
      for (let index = 1; index <= minPage; index++) {
        setPageNumberArray(current => [
          ...current,
          { page: index, type: "number" },
        ]);
      }
    } else {
      const startValue = currentPage - 4; // Adjusted to start from currentPage - 4
      const endValue = pageCount - currentPage;

      let startIndex = Math.max(0, startValue - 1); // Adjusted to ensure startIndex >= 0
      let endIndex = 0;

      if (startIndex <= 0) {
        endIndex = Math.min(pageCount, 7); // Adjusted to ensure endIndex does not exceed pageCount
      } else if (endValue < 4) {
        startIndex = Math.max(0, pageCount - 6); // Adjusted to ensure startIndex >= 0
        endIndex = pageCount; // Adjusted to display all pages
      } else {
        endIndex = Math.min(startIndex + 7, pageCount); // Adjusted to ensure endIndex does not exceed pageCount
      }

      const startDis = startIndex > 1;
      if (startDis) {
        setPageNumberArray(current => [
          ...current,
          { page: 1, type: "number" }
        ]);
        setPageNumberArray(current => [
          ...current,
          { page: "...", type: "start" },
        ]);
      }

      for (let index = startIndex; index < endIndex; index++) {
        setPageNumberArray(current => [
          ...current,
          { page: index + 1, type: "number" },
        ]);
      }

      const endDis = endIndex < pageCount - 1;
      if (endDis) {
        // setPageNumberArray(current => [
        //   ...current,
        //   { page: "...", type: "end" },
        // ]);
        setPageNumberArray(current => [
          ...current,
          { page: pageCount, type: "number" },
        ]);
      }
    }
  }, [pageIndex, pageCount]);

  const generateSortingIndicator = (column) => {
    const isColumnSorted = sortOptions.column === column.id;
    const isColumnInOptional = sortOptions.optionalColumn.indexOf(column.id) === -1;
    const isAsc = sortOptions.isAsc;

    if (isColumnSorted && isColumnInOptional) {
      return isAsc ? "bx bx-chevron-up ps-1 pe-1 font-size-20" : "bx bx-chevron-down ps-1 pe-1 font-size-20";
    }

    return isColumnInOptional ? "bx bx-chevron-up ps-1 pe-1 font-size-20 grey" : "";
  };

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
    handlePageChange(1, Number(event.target.value))
  }

  const gotoPage = page => {
    if (page > 0 && page <= pageCount);
    handlePageChange(page, pageSize);
  }

  const paginationClick = (pageData, index) => {
    const { page, type } = pageData;
    if (type === "number") {
      gotoPage(page);
    } else if (type === "start") {
      const nextPage = pageNumberArray[index + 1];
      gotoPage(nextPage.page - 1);
    } else if (type === "end") {
      const nextPage = pageNumberArray[index - 1];
      gotoPage(nextPage.page + 1);
    }
  };


  const handleSortColumnClick = column => {
    if (!sortOptions || sortOptions.optionalColumn.indexOf(column.id) > -1)
      return

    if (sortOptions.column == column.id) {
      handleSortColumn(
        Object.assign(sortOptions, {
          column: column.id,
          isAsc: !sortOptions.isAsc,
        })
      )
    } else {
      handleSortColumn(
        Object.assign(sortOptions, { column: column.id, isAsc: false })
      )
    }
  }

  const callSearchFilter = value => {
    handleSearchFilter(value, pageSize)
  }

  const callFilter = value => {
    handleFilter(value, pageSize)
  }

  const canNextPage = () => {
    return pageIndex < pageCount
  }

  const canPreviousPage = () => {
    return pageIndex > 1
  }

  const getVisibleColumns = (columns, tableWidth, scrollable) => {
    let visibleColumns = [];
    let hiddenColumn = [];
    let columnWidth = 0;
    
    const uniqueColumns = Array.from(new Set(columns.map(col => col.Header)))
        .map(header => columns.find(col => col.Header === header));
    
    const sortedColumns = uniqueColumns
      .map((column, index) => ({ ...column, order: index }))
      .sort((a, b) => (a.hideOrder || 0) - (b.hideOrder || 0));

    sortedColumns.forEach((column) => {
      columnWidth += column.width;
      if (column.hideOrder && tableWidth <= columnWidth) {
        hiddenColumn.push(column.Header);
      } else {
        visibleColumns.push(column.Header);
      }
    });
    
    setVisibleColumns(visibleColumns);
    setHiddenColumns(hiddenColumn);
};
useEffect(() => {
  getVisibleColumns(columns, tableWidth);
}, [columns,tableWidth]);

  const handleExpandClick = (rowIndex) => {
    setExpandedRows(prevState => {
      if (prevState.includes(rowIndex)) {
        return prevState.filter(index => index !== rowIndex);
      } else {
        return [...prevState, rowIndex];
      }
    });
  };

  return (
    <Fragment>
      <Row className="mb-2">

        <Col md="6">

          <div className="d-flex flex-column flex-md-row gap-1">
            {!hidePageSize &&
              <select
                className="form-select  me-3 show-dropdown"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {customPageSizeOptions.map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            }
            {!hideSearchView && handleSearchFilter && (
              <>
                <GlobalFilter
                  totalRecords={totalRecords}
                  setSearchFilter={callSearchFilter}
                  handleClearSearch={handleClearSearch}
                  handleTableFor={tableFor}
                  setCallFilter={callFilter}
                  activeTab={activeTab}
                  handleFilter={handleFilter}
                />
              </>
            )}
          </div>

        </Col>

        <Col sm="6">{customSection}</Col>
      </Row>

      <div ref={tableContainerRef}  className="table-responsive react-table">
        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {(hiddenColumns.length>0) && (<th style={{width:`10px`}}></th>)}
                {headerGroup.headers.map(column => (
                  
                  visibleColumns.includes(column?.Header) && (<th key={column.id}>
                    <div onClick={() => handleSortColumnClick(column)}>
                      <span id={`tooltip-${column.id}`}>{column.render('Header')}</span>
                      {column.FullName && (
                        <UncontrolledTooltip placement="top" target={`tooltip-${column.id}`}>
                          {column.FullName || ""}
                        </UncontrolledTooltip>
                      )
                      }
                      {sortOptions && (
                        <i className={generateSortingIndicator(column)}></i>
                      )}
                    </div>
                  </th>)
                ))}
              </tr>
            ))}
          </thead>

          {page.length == 0 ? (
            <tbody>
              <tr>
              <td colSpan={headerGroups[0].headers.length} className="text-center no-data-found">
  No data found
</td>

              </tr>
            </tbody>
          ) : (
            <tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {(hiddenColumns.length>0) && (<td
                        className={`${index % 2 === 0 ? "table-row-odd" : "table-row-even"}`}
                        onClick={() => handleExpandClick(index)}
                      >
                        <div
                          className="font-size-18 text-success"
                        >
                          <i className={`bx bxs-${expandedRows.includes(index) ? 'minus' : 'plus'}-circle`}></i>
                        </div>
                      </td>)}
                      {row.cells.map(cell => {
                        if (visibleColumns.includes(cell.column.Header)) {
                          return (
                            <td
                              key={cell.id}
                              {...cell.getCellProps()}
                              className={`${index % 2 === 0 ? "table-row-odd" : "table-row-even"}`}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </tr>
                    {expandedRows.includes(index) && (
                      <tr className="expanded-row">
                        <td colSpan={12} className={`${index % 2 === 0 ? "table-row-odd" : "table-row-even"}`}>
                          <Row>
                            {row.cells.map(cell => {
                              if (hiddenColumns.includes(cell.column.Header) && cell.column.Header !== "Apply Loan") {
                                return (
                                  <Col
                                    sm="12" md="6"
                                    key={cell.id}
                                    {...cell.getCellProps()}
                                  >
                                    <div className="grid-container mt-2">
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                      
                                        <strong style={{ minWidth: '120px' }}>{cell.column.Header}</strong>
                                        <span>:</span>
                                        <div className="ms-2 cell-width">{cell.render("Cell")}</div>
                                    </div>
                                </div>
                                  </Col>
                                );
                              } else if(hiddenColumns.includes(cell.column.Header) && cell.column.Header == "Apply Loan"){
                                return (
                                  <Col
                                    sm="12" md="6"
                                    key={cell.id}
                                    {...cell.getCellProps()}
                                  >
                                    <div className="grid-container mt-2">
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                      
                                        {/* <strong style={{ minWidth: '120px' }}>{cell.column.Header}</strong> */}
                                        {/* <span>:</span> */}
                                        <div className="cell-width">{cell.render("Cell")}</div>
                                    </div>
                                </div>
                                  </Col>
                                );
                              }
                              else {
                                return null;
                              }
                            })}
                          </Row>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                )
              })}
            </tbody>
          )}
        </Table>
      </div>

      <Row>
        <Col
          md="6"
          className="d-flex justify-content-md-start justify-content-center align-items-center mt-md-0 mb-md-0 mt-2 mb-2"
        >
          {pageIndex > 0 &&
            <>
              Showing
              <span className="text-bold">{((pageIndex - 1) * pageSize + 1) || 0}</span> to
              <span className="text-bold">
                {((pageIndex - 1) * pageSize + (data.length || 0)) || 0}
              </span>{" "}
              of
              <span className="text-bold">{totalRecords || 0}</span> records
            </>
          }
        </Col>
        <Col
          md="6"
          className="d-flex justify-content-md-end justify-content-center align-items-center"
        >
          {pageIndex > 0 &&
            <>
              <div className="d-flex gap-1">
                <img
                  className={`pagination__button pagination__page-first ${!canPreviousPage() ? "pagination__button--disabled" : ""
                    }`}
                  src={LeftArrow}
                  alt="FirstPage"
                  onClick={() => gotoPage(1)}
                  title="Go to First page"
                />
                <img
                  className={`pagination__button pagination__page-previous ${!canPreviousPage() ? "pagination__button--disabled" : ""
                    }`}
                  src={PreviousArrow}
                  alt="PrevPage"
                  onClick={() => {
                    gotoPage(pageIndex - 1)
                  }}
                  title="Previous Page"
                />
              </div>
              <div className="d-flex pagination-container">
                {pageNumberArray.map((page, index) => {
                  return (
                    <Fragment key={page.page}>
                      <span
                        color="primary"
                        key={page}
                        onClick={() => {
                          paginationClick(page, index)
                        }}
                        className={`pagination_number ${pageIndex == page.page
                          ? "pagination_number--selected"
                          : ""
                          }`}
                      >
                        {page.page}
                      </span>
                    </Fragment>
                  )
                })}
              </div>
              <div className="d-flex gap-1">
                <img
                  className={`pagination__button pagination__page-first ${!canNextPage() ? "pagination__button--disabled" : ""
                    }`}
                  src={NextArrow}
                  alt="GoToNext"
                  onClick={() => gotoPage(pageIndex + 1)}
                  title="Next Page"
                />
                <img
                  className={`pagination__button pagination__page-previous ${!canNextPage() ? "pagination__button--disabled" : ""
                    }`}
                  src={RightArrow}
                  alt="LasPage"
                  onClick={() => {
                    gotoPage(pageCount)
                  }}
                  title="Go to Last Page"
                />
              </div>
            </>
          }
        </Col>
      </Row>
    </Fragment>
  )
}

TableContainerV1.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TableContainerV1;
